import React from "react";
import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import { useState } from "react";
import CountryCode from "./CountryCode";
import {
  getXanoAuthEmailToken,
  sendOtp,
  verifyOtp,
  resendOtp,
  resetPassword,
  logout,
  sendOtpFromEmail,
  getXanoAuthToken,
  requestOtp,
  validatePasswordResetAccess,
  updatePassword,
  requestResendOtp,
  setOnboardingPhase,
} from "../../redux/actions/authentication";
import { toast } from "react-toastify";
import { axiosAuth } from "../../config/axiosInstances";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Mixpanel } from "../../config/Mixpanel";
import ReactPixel from "react-facebook-pixel";
import Constants from "../../common/constants";
import { useCookies } from "react-cookie";
import GoogleLogin from "react-google-login";
import { XANO_GOOGLE_CLIENT_ID } from "../../config/api_config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { countryPhoneCodes } from "./countryPhoneCode";
import { PhoneNumberUtil } from "google-libphonenumber";
import { useSearchParams } from "react-router-dom";
import { setActivationPhase } from "../../redux/actions/contentPayer";
import { SET_IS_ACTIVATION } from "../../redux/actions/types";
import { fetchIsUserFromBetaProduct } from "../../redux/actions/personaliseCourse";
import LoginLogo from "../../components/Navbar/NavBarRight/LoginLogo";

const LoginWithEmailModal = ({ isModalEnabled, setIsModalEnabled }) => {
  const [emailFormData, setEmailFormData] = useState({
    email: "",
    password: "",
  });
  const [email, setEmail] = useState("");
  const [phoneNumber , setPhoneNumber ] = useState("");
  const [isEmailFormEnabled, setIsEmailFormEnabled] = useState(true);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [userJWT, setUserJWT] = useState(null);
  const [mobile, setMobile] = useState("");
  const [OTP, setOTP] = useState("");
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isResendOtp, setIsResendOtp] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    countryPhoneCodes.find((el) => el?.name === "India")
);
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [isVerifyOtpLoading, setIsVerifyOtpLoading] = useState(false);
  const [isSendOtpLoading, setIsSendOtpLoading] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isResetLoading, setIsResetLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false)
  const [cookies, setCookie, removeCookie] = useCookies();
  const [isVisible , setIsVisible] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const phoneUtil = PhoneNumberUtil.getInstance();
  const regex = /^\d+$/;
  const [authToken , setAuthToken] = useState("");
  const [originalPhoneNumber , setOriginalPhoneNumber] = useState("");
  const [originalEmail , setOriginalEmail] = useState("");
  const [searchParams, setSearchParams] = useSearchParams()

 console.log('country' , userJWT);
  const onSubmit = () => {
    // console.log(email);
    setIsSendOtpLoading(true);
    setOriginalEmail(email);
    setOriginalPhoneNumber(selectedCountry?.dial_code + phoneNumber);
    if(email?.length > 0){
      dispatch(
        requestOtp(
          email,
          "",
          "email",
          (successObj) => {
            if (successObj?.result === "success") {
              //console.log(response.data.jwt);
              setIsOtpSent(true);
              toast.success(successObj?.message, {
                closeButton: false,
              });
              setUserJWT(successObj?.data?.jwt);
              setPhoneNumber(successObj?.data?.phone_number);
              //successCallback(response);
            }
            else{
              toast.error(successObj?.message);
              setIsSendOtpLoading(false);
            }
          },
          (errorObj) => {
            toast.error("Enter Valid Email");
            setIsSendOtpLoading(false);
          }
        )
      );


    }
    else{
    if( (selectedCountry?.dial_code + phoneNumber)[0] === '+' && regex.test((selectedCountry?.dial_code + phoneNumber).slice(1))){
      if (!phoneUtil.isValidNumberForRegion(phoneUtil.parse(phoneNumber, selectedCountry?.code),selectedCountry?.code)){
          toast.error('Enter Valid Phone Number')
          return
      } else {
         
        dispatch(
          requestOtp(
            "",
            selectedCountry?.dial_code + phoneNumber,
            "phone_number",
            (successObj) => {
              if (successObj?.result === "success") {
                //console.log(response.data.jwt);
                setIsOtpSent(true);
                toast.success(successObj?.message, {
                  closeButton: false,
                });
                setUserJWT(successObj?.data?.jwt);
                setPhoneNumber(successObj?.data?.phone_number);
                //successCallback(response);
              }
              else{
                toast.error(successObj?.message);
                setIsSendOtpLoading(false);
              }
            },
            (errorObj) => {
              toast.error("Enter Valid Email");
              setIsSendOtpLoading(false);
            }
          )
        );
  
      }}
    else{
      toast.error('Enter Valid Phone Number')
      return
    }
  }
    

   
  };
console.log({isEmailFormEnabled : isEmailFormEnabled ,  })
  const verifyOTP = () => {
    setIsVerifyOtpLoading(true);
    dispatch(
      validatePasswordResetAccess(userJWT, OTP, (successObj) => {
        //console.log(successObj);
        if (successObj?.result === "success") {
          console.log('it ran');
          setIsOtpVerified(true);
          setAuthToken(successObj?.data?.authToken);
          setEmail(successObj?.data?.email);
          ReactPixel.trackSingle("333999584825866", "Lead")
        }
        else{
          toast.error(successObj?.message, {
            closeButton: false,
          });
          setIsVerifyOtpLoading(false);
        }
      })
    );
  };

  const resendOTP = (type) => {
   
    if(originalEmail?.length > 0){
      dispatch(
        requestResendOtp(originalEmail,"","email",type ,(successObj) => {
          //console.log(success);
          if (successObj?.result === "success") {
            //console.log(response.data.jwt);
            setIsOtpSent(true);
            toast.success(successObj?.message, {
              closeButton: false,
            });
            setPhoneNumber(successObj?.data?.phone_number);
            //successCallback(response);
          }
          else{
            toast.error(successObj?.message);
            setIsSendOtpLoading(false);
          }
          
        } , (errorObj)=>{
          toast.error("Enter Valid Email");
          setIsSendOtpLoading(false);
        }
        )
      );
    }
    else{
      dispatch(
        requestResendOtp("",originalPhoneNumber,"phone_number",type ,(successObj) => {
          //console.log(success);
          if (successObj?.result === "success") {
            //console.log(response.data.jwt);
            setIsOtpSent(true);
            toast.success(successObj?.message, {
              closeButton: false,
            });
            setPhoneNumber(successObj?.data?.phone_number);
            //successCallback(response);
          }
          else{
            toast.error(successObj?.message);
            setIsSendOtpLoading(false);
          }
          
        }, (errorObj)=>{
          toast.error("Enter Valid Phone Number");
          setIsSendOtpLoading(false);

        })
      );

    }
  };

  const onChange = (event) => {
    setEmailFormData({
      ...emailFormData,
      [event.target.name]: event.target.value,
    });
  };

  const emailSignIn = () => {
    setIsLoginLoading(true);
    dispatch(
      getXanoAuthEmailToken(
        emailFormData.email,
        emailFormData.password,
        (successObj) => {
          setIsModalEnabled(false);
          const userId = successObj?.user_coins_data?.[0]?.user_id;

          Mixpanel.identify(successObj?.email);
          Mixpanel.track(Constants.Mixpanel.LOG_IN, {
            distinct_id: successObj?.email,
          });
          Mixpanel.people.set({
            $first_name: successObj?.first_name,
            $last_name: successObj?.last_name,
          });
          if (successObj.number_verification) {
            if(searchParams.get("course")){
              navigate(`/course/${searchParams?.get("course")}`);
            }
            else{
              navigate(
                location?.state?.from?.pathname
                  ? location?.state?.from?.pathname
                  : "/courses",
                { replace: true }
              );
            }
            
          } else {
            // ReactPixel.trackSingle("333999584825866", "Lead");
            if(successObj?.show_toast){
              toast.error(successObj?.message);
            }
            else{
              if(searchParams.get("course")){
                navigate(`/verification/${searchParams?.get("course")}`);
              }
              else{
                navigate('/verification')
              }
            }
          }
        },
        (errorObj) => {
          if(errorObj.response.data.message === 'Invalid password syntax.'){
          toast.error("Try Login with Google/Facebook");
          }
          else{
          toast.error("Enter Valid Credentials");
          }
          setIsLoginLoading(false);
        }
      )
    );

    dispatch(fetchIsUserFromBetaProduct((res)=>{
      console.log('monday' , res)
      if(res?.data?.is_ninjacurate_user ||
      res?.data?.ninjacurate_is_paid){

          dispatch(setOnboardingPhase((res1)=>{} , (err1)=>{}));
          dispatch(
              setActivationPhase((successObj) =>
                dispatch({ type: SET_IS_ACTIVATION, payload: false })
              )
            );
      }

  },(err)=>{}))
  };
  
  function logoutHandler() {
    dispatch(logout());
    removeCookie("authToken", { path: "/" });
    navigate("/courses");
  }

  const onResetPassword = () => {
    setIsResetLoading(true);
    if (passwords.newPassword !== passwords.confirmPassword) {
      toast.error("Passwords do not Match");
      setIsResetLoading(false);
    } else if (passwords.newPassword.length < 8) {
      toast.error("Minimum 8 characters Required!!");
      setIsResetLoading(false);
    } else {
      dispatch(
        updatePassword(authToken, passwords.newPassword, (successObj) => {
          //console.log(successObj);
          setIsModalEnabled(false);
          toast.success(`Password Changed, Login Again`, {
            closeButton: false,
          });

          logoutHandler();
        })
      );
    }
  };

  async function authResponse(response) {
    setIsGoogleLoading(true)
    if (response.error || (response.status && response.status === "unknown")) {
        setIsGoogleLoading(false)
        console.log("Auth Failed: ", response.error);
    } else {
        const tokenID = response?.tokenObj?.access_token;
        await dispatch(
            getXanoAuthToken(tokenID, (successObj) => {
            Mixpanel.identify(successObj?.email);
            Mixpanel.track(Constants.Mixpanel.LOG_IN, {
                distinct_id: successObj?.email,
            });
            Mixpanel.people.set({
                $first_name: successObj?.first_name,
                $last_name: successObj?.last_name,
            });
            if (successObj?.number_verification) {
                navigate(
                location?.state?.from?.pathname
                    ? location?.state?.from?.pathname
                    : "/courses",
                { replace: true }
                );
                setIsGoogleLoading(false)
            } else {
                if(successObj?.show_toast){
                    toast.error(successObj?.message);
                    //setIsLoading(false);
                    setIsGoogleLoading(false)
                }
                else{
                  setIsModalEnabled(false);
                    navigate('/verification');
                }
            }})
        )}
}

  if (isEmailFormEnabled === true) {
    return (
      <div>
        <Dialog
          open={isModalEnabled}
          onClose={() => setIsModalEnabled(!isModalEnabled)}
          as="div"
          className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className="z-10 flex w-11/12 flex-col py-6 px-4 items-center justify-center rounded-xl bg-[#2D4F71] shadow-2xl md:w-3/5  lg:w-[25%]">
          <div className="mx-auto flex items-center bg-white py-1 px-2 rounded ">
               <LoginLogo/>
            </div>
            <div className="flex w-full flex-col items-center justify-center mt-4">
              <div className="mb-2 w-full self-start">
                <h1 className=" mb-5 text-[20px] font-semibold text-white">
                  Login To Your Account
                </h1>
                <label
                  htmlFor="email-address"
                  className="text-[16px] font-medium text-white"
                >
                  Email
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  required
                  onChange={onChange}
                  className="w-full appearance-none  rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                />
              </div>
              <div className="mb-2 self-start w-full">
                <label htmlFor="password" className="text-[16px] font-medium text-white">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  required
                  onChange={onChange}
                  className="w-full appearance-none  rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                />
              </div>
              <a
                className=" cursor-pointer self-start text-[14px] font-semibold text-white underline "
                onClick={(e) => setIsEmailFormEnabled(false)}
              >
                Forgot Email/Password?
              </a>
              <button
                disabled={isLoginLoading}
                className=" mt-4 h-10 w-full rounded-lg font-bold bg-[#25BD4C] text-[16px] text-white"
                onClick={(event) => emailSignIn()}
              >
                {isLoginLoading ? "Logging In..." : "Login"}
              </button>
            </div>
            <div className="w-full text-center mt-2">
              <div className="text-white text-[12px] font-semibold">Or</div>
              <GoogleLogin
                      clientId={XANO_GOOGLE_CLIENT_ID}
                      render={(renderProps) => {
                          return (
                              <button onClick={renderProps.onClick} disabled={renderProps.disabled} className="mt-2 w-full rounded-md relative bg-[#1CA571] px-2 py-3 text-sm font-semibold text-white md:text-lg"
                              >
                                  <div className="w-7 h-7 absolute top-2 left-2.5 bg-white rounded-full">
                                      <img src="https://assets.learntube.ai/files/Onboarding_Revamp/image%20479.png?updatedAt=1694429827511" width={28} height={28} alt="google image" />
                                  </div>
                                  <p className="mx-auto text-center font-semibold text-[16px] text-white">Sign In With Google</p>
                              </button>)}}
                      onSuccess={authResponse}
                      onFailure={authResponse}
                      cookiePolicy={"single_host_origin"}
                  />
            </div>
          </div>
        </Dialog>
      </div>
    );
  } else if (isOtpVerified === true) {
    return (
      <div>
        <Dialog
          open={isModalEnabled}
          onClose={() => setIsModalEnabled(!isModalEnabled)}
          as="div"
          className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className="z-10 flex w-11/12 flex-col py-6 px-4 items-center justify-center rounded-xl bg-[#2D4F71] shadow-2xl md:w-3/5  lg:w-[25%]">
            <div className="mx-auto flex items-center bg-white py-1 px-2 rounded ">
                <LoginLogo/>
            </div>
            <div className="flex w-full flex-col items-center justify-center">
              <div className="mt-4 flex w-full leading-tight flex-col self-start">
                <h1 className="text-[20px] font-semibold text-white">Reset Password</h1>
                <div className="font-medium text-[14px] text-gray-300">Email: {email}</div>
                <div className="mt-4 flex flex-col">
                  <label htmlFor="password" className="text-[16px] font-medium text-white">
                    New Password
                  </label>
                  <div className="mt-1 flex h-[44px] w-full ">
                    <input
                      id="newpassword"
                      name="password"
                      type={isVisible ? "text" : "password"}
                      onChange={(event) =>
                        setPasswords({
                          ...passwords,
                          newPassword: event.target.value,
                        })
                      }
                      required
                      className="w-full appearance-none rounded-l-lg border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                    />
                    <FontAwesomeIcon
                        icon={isVisible ? faEyeSlash : faEye}
                        className="cursor-pointer rounded-tr-lg rounded-br-lg bg-[#223548] p-3.5 text-[#7FC241]"
                        onClick={(e) => setIsVisible(!isVisible)}
                      />
                  </div>
                </div>
                <div className="mt-4 flex flex-col ">
                  <label htmlFor="password" className="text-[16px] font-medium text-white">
                    Confirm New Password
                  </label>
                  <input
                    id="confirmpassword"
                    name="password"
                    type="password"
                    onChange={(event) =>
                      setPasswords({
                        ...passwords,
                        confirmPassword: event.target.value,
                      })
                    }
                    required
                    className="w-full appearance-none  rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
              </div>
              <button
                disabled={isResetLoading}
                className="mt-4 h-10 w-full rounded-lg bg-[#25BD4C] font-bold text-[16px] text-white"
                onClick={(event) => onResetPassword()}
              >
                {isResetLoading ? "Updating Password..." : "Reset Password"}
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  } else if (isOtpSent === true) {
    return (
      <div>
        <Dialog
          open={isModalEnabled}
          onClose={() => setIsModalEnabled(!isModalEnabled)}
          as="div"
          className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className="z-10 flex w-11/12 flex-col py-6 px-4 items-center justify-center rounded-xl bg-[#2D4F71] shadow-2xl md:w-3/5  lg:w-[25%]">
          <div className="mx-auto flex items-center bg-white py-1 px-2 rounded ">
               <LoginLogo/>
            </div>
            <div className="flex w-full flex-col items-center justify-center">
              <div className="mt-4 w-full self-start">
                <h1 className="text-[20px] font-semibold text-white ">Verify OTP</h1>
                <h4 className="text-[14px] text-stone-300">
                  OTP sent to your Registered phone number.
                </h4>
                <h4
                  className="mb-7 cursor-pointer self-start text-xs font-medium text-[#18A5D6] underline "
                  onClick={(e) => {
                    setEmail("");
                    setPhoneNumber("");
                    setOriginalEmail("");
                    setOriginalPhoneNumber("");
                    setIsOtpSent(false);
                    setUserJWT(null);
                    setIsSendOtpLoading(false);
                    setMobile("");
                  }}
                >
                  Change {phoneNumber}?
                </h4>
                <h1 className="text-[16px] text-white font-medium">Enter OTP</h1>
                <input
                  id="otp"
                  name="otp"
                  type="text"
                  onChange={(event) => setOTP(event.target.value)}
                  required
                  className="w-full appearance-none rounded-md border border-[#223548] bg-[#223548] px-3 py-2 text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                />
              </div>
              <a
                className="mt-2 cursor-pointer self-start text-xs text-white text-[14px] font-semibold underline"
                onClick={(e) => {
                  setIsResendOtp(!isResendOtp);
                }}
              >
                Resend OTP
              </a>
              {isResendOtp && (
                <div className="mt-2 mb-2 flex w-full items-center justify-between gap-2">
                  <button
                    className="w-full cursor-pointer rounded bg-cn_green p-2 text-sm text-white hover:bg-green-400 disabled:bg-slate-400"
                    onClick={() => resendOTP("voice")}
                  >
                    OTP On Call
                  </button>
                  <button
                    className="w-full cursor-pointer rounded bg-cn_green p-2 text-sm text-white hover:bg-green-400 disabled:bg-slate-400"
                    onClick={() => resendOTP("text")}
                  >
                    OTP on SMS
                  </button>
                </div>
              )}

              <button
                disabled={isVerifyOtpLoading}
                className=" mt-4 h-10 w-full  font-bold rounded-lg bg-[#25BD4C] text-white"
                onClick={(event) => verifyOTP()}
              >
                {isVerifyOtpLoading ? "Verifying..." : "Verify"}
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div className="overflow-hidden">
        <Dialog
          open={isModalEnabled}
          onClose={() => setIsModalEnabled(!isModalEnabled)}
          as="div"
          className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-hidden"
        >
          <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
          <Dialog.Title />
          <Dialog.Description />
          <div className="z-10 flex w-11/12 flex-col py-6 px-4 items-center justify-center rounded-xl bg-[#2D4F71] shadow-2xl md:w-3/5  lg:w-[25%]">
          <div className="mx-auto flex items-center bg-white py-1 px-2 rounded ">
               <LoginLogo/>
            </div>
            <div className="flex w-full flex-col items-center justify-center mt-4 ">
              <div className="mb-2 flex w-full flex-col self-start">
                <h1 className="  text-[20px] font-semibold text-white">Forgot Email/Password</h1>
                {/* <small className="mb-7 text-xs text-stone-500 ">
                  Enter your email address to send OTP to your registered number
                  to reset password
                </small> */}

                <div className="mt-4">
                  <label
                    htmlFor="email-address"
                    className="text-[16px] font-medium text-white"
                  >
                    Email
                  </label>
                  <input
                    id="email-address"
                    name="email"
                    type="email"
                    disabled={phoneNumber?.length > 0}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                    className="w-full appearance-none disabled:bg-gray-400 rounded-md border border-[#223548] bg-[#223548] text-white placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                  <div className="text-white text-center my-4 text-[12px] font-semibold">Or</div>
                   <label
                    htmlFor="email-address"
                    className="text-[16px] font-medium text-white"
                  >
                    Phone Number
                  </label>
                  <div className="flex gap-2">
                        <div className="w-[35%]">
                            <CountryCode
                                selected={selectedCountry}
                                setSelected={setSelectedCountry}
                                disable={email?.length > 0}
                            />
                        </div>
                        <div className="mt-1 flex-1">
                            <input
                                id="phone-number"
                                name="phone"
                                type="tel"
                                disabled={email?.length > 0}
                                onChange={(event) => setPhoneNumber(event.target.value)}
                                placeholder="Phone Number"
                                pattern="[0-9.]+"
                                required
                                className={`w-full bg-[#223548] appearance-none rounded-md border px-3 py-2  
                                ${'text-white/50'} placeholder:text-sm disabled:bg-gray-400 placeholder:text-white/50 placeholder:font-semibold focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm`}
                            />
                        </div>
                    </div>
                </div>
              </div>
              <button
                disabled={isSendOtpLoading}
                className="mt-4 h-10 w-full rounded-lg bg-[#25BD4C] text-white"
                onClick={(event) => onSubmit()}
              >
                {isSendOtpLoading ? "Sending..." : "Send OTP"}
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
};

export default LoginWithEmailModal;
